import { supabase } from './supabase'

/**
 * Log an audit event
 */
export const logAuditEvent = async (organizationId, actionType, resourceType, resourceId = null, details = {}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    // Get IP address from headers if available (would need to be passed from server)
    const ipAddress = null // Would be set by server-side function
    
    const { data, error } = await supabase
      .from('audit_logs')
      .insert({
        organization_id: organizationId,
        user_id: user?.id,
        action_type: actionType,
        resource_type: resourceType,
        resource_id: resourceId,
        details: details,
        ip_address: ipAddress,
        user_agent: navigator.userAgent,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error logging audit event:', error)
    // Don't throw - audit logging should not break the app
  }
}

/**
 * Log an access event
 */
export const logAccessEvent = async (organizationId, resourceType, resourceId, accessType) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('access_logs')
      .insert({
        organization_id: organizationId,
        user_id: user?.id,
        accessed_resource_type: resourceType,
        accessed_resource_id: resourceId,
        access_type: accessType,
        user_agent: navigator.userAgent,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error logging access event:', error)
  }
}

/**
 * Get audit logs for organization
 */
export const getAuditLogs = async (organizationId, filters = {}) => {
  try {
    let query = supabase
      .from('audit_logs')
      .select('*, user:user_id(email, raw_user_meta_data)')
      .eq('organization_id', organizationId)
      .order('created_at', { ascending: false })
      .limit(1000)

    if (filters.userId) {
      query = query.eq('user_id', filters.userId)
    }
    if (filters.resourceType) {
      query = query.eq('resource_type', filters.resourceType)
    }
    if (filters.actionType) {
      query = query.eq('action_type', filters.actionType)
    }
    if (filters.startDate) {
      query = query.gte('created_at', filters.startDate)
    }
    if (filters.endDate) {
      query = query.lte('created_at', filters.endDate)
    }

    const { data, error } = await query

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching audit logs:', error)
    throw error
  }
}

/**
 * Get access logs for organization
 */
export const getAccessLogs = async (organizationId, filters = {}) => {
  try {
    let query = supabase
      .from('access_logs')
      .select('*, user:user_id(email, raw_user_meta_data)')
      .eq('organization_id', organizationId)
      .order('created_at', { ascending: false })
      .limit(1000)

    if (filters.userId) {
      query = query.eq('user_id', filters.userId)
    }
    if (filters.resourceType) {
      query = query.eq('accessed_resource_type', filters.resourceType)
    }
    if (filters.startDate) {
      query = query.gte('created_at', filters.startDate)
    }
    if (filters.endDate) {
      query = query.lte('created_at', filters.endDate)
    }

    const { data, error } = await query

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching access logs:', error)
    throw error
  }
}

